import { useState } from 'react'

import { Space } from '@tribeplatform/gql-client/types'
import { SpacePicker } from '@tribeplatform/react-sdk/components'
import { useNetwork, useUpdateNetwork } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

export const DefaultSpacesSettings = () => {
  const { mutateAsync: updateNetwork, isLoading } = useUpdateNetwork()
  const { data: network } = useNetwork()

  const [spaces, setSpaces] = useState<Space[]>(network?.defaultSpaces)

  return (
    <Card>
      <Card.Header
        title="Default spaces"
        description="Select which spaces you’d like to automatically add new members to."
      />
      <Card.Content>
        <div className="flex flex-col space-y-5">
          <SpacePicker onChange={setSpaces} value={spaces} multiple />
          <div className="flex justify-end">
            <Button
              loading={isLoading}
              onClick={async () => {
                try {
                  await updateNetwork({
                    input: {
                      defaultSpaceIds: spaces.map(space => space.id),
                    },
                  })
                  toast({
                    title: 'Default spaces updated',
                    status: 'success',
                  })
                } catch (e) {
                  toast({
                    title: 'Unable to update default spaces',
                    status: 'error',
                  })
                }
              }}
            >
              Update
            </Button>
          </div>
        </div>
      </Card.Content>
    </Card>
  )
}
